/**
 * Settings > Help & Safety (the phone app; docs/mobile/store-compliance.md
 * S6, S7): how to report, the safety team and support by email, and the
 * public pages (privacy, terms, guidelines, child safety, account deletion,
 * help). The links open in the system browser or mail app (lib/mobileGlue.ts).
 */
import { useT } from '../i18n';
import { Icon } from '../ui/kit';
import { SetGroup, SetRow } from './Settings';

export const SAFETY_EMAIL = 'safety@neoxify.com';
export const SUPPORT_EMAIL = 'support@neoxify.com';

const SITE = 'https://neoxify.app';

const PAGES: Array<{ path: string; label: string }> = [
  { path: '/privacy', label: 'mob.help.privacy' },
  { path: '/terms', label: 'mob.help.terms' },
  { path: '/guidelines', label: 'mob.help.guidelines' },
  { path: '/child-safety', label: 'mob.help.childSafety' },
  { path: '/delete-account', label: 'mob.help.deleteAccount' },
  { path: '/support', label: 'mob.help.supportPage' },
];

function Mail({ to }: { to: string }) {
  return (
    <a className="nx-btn ghost sm" href={`mailto:${to}`} dir="ltr">
      <Icon name="mail" />
      <span className="lbl">{to}</span>
    </a>
  );
}

export function HelpSection() {
  const { t } = useT();
  return (
    <>
      <h2>{t('mob.help.title')}</h2>
      <SetGroup>
        <SetRow label={t('mob.help.report')} sub={t('mob.help.reportSub')} stack>
          <Mail to={SUPPORT_EMAIL} />
        </SetRow>
        <SetRow label={t('mob.help.safety')} sub={t('mob.help.safetySub')} stack>
          <Mail to={SAFETY_EMAIL} />
        </SetRow>
        <SetRow label={t('mob.help.support')} sub={t('mob.help.supportSub')} stack>
          <Mail to={SUPPORT_EMAIL} />
        </SetRow>
      </SetGroup>
      <SetGroup title={t('mob.help.pages')}>
        {PAGES.map((p) => (
          <SetRow key={p.path} label={t(p.label)}>
            <a
              className="nx-btn ghost sm"
              href={SITE + p.path}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={t(p.label)}
            >
              <Icon name="link" />
            </a>
          </SetRow>
        ))}
      </SetGroup>
    </>
  );
}
